import { connectionStore } from "../../Stores";
import { STR_ERRORS } from "../../Strings";
export function applyRESTQueries(connection, message, meta) {
    const c = connectionStore.get(connection);
    if (!c) {
        return Promise.reject(STR_ERRORS.NoConnectionsAvailable);
    }
    return c.send(Object.assign(Object.assign({}, message), { meta }));
}
//# sourceMappingURL=ApplyRESTQueries.js.map